import { module } from 'modujs';

const CLASS = {
    OPEN: `has-prev-show`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            mouseenter: {
                prev: 'togglePrev',
            },
            mouseleave: {
                prev: 'togglePrev'
            },
        }
    }

    init(){

    }

    togglePrev(e) {
        const target = e.curTarget;
        const container = this.parent('container', target);

        if (container.classList.contains(CLASS.OPEN)) {
            container.classList.remove(CLASS.OPEN);
        } else {
            container.classList.add(CLASS.OPEN);
        }
    }
}
